import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Checkbox.scss';

const Checkbox = ({ variantClasses = [], id, label, innerHTML, selected, inputChange, children, isError = false }) => {
	const inputChangeHandler = (e) => {
		const $checkbox = e.currentTarget;
		inputChange($checkbox.id, $checkbox.checked);
	};

	const labelAttributes = {};
	label = label || children || null;
	const checkboxClasses = [s.checkbox];
	if (isError === true) checkboxClasses.push(s.checkbox__error);
	if (innerHTML) labelAttributes.dangerouslySetInnerHTML = { __html: purifier(innerHTML) };

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		checkboxClasses.push(s[c]);
	});

	return (
		<label key={id} htmlFor={id} className={checkboxClasses.join(' ')}>
			<input className={s.checkbox_input} id={id} type="checkbox" name={id} value="1" checked={selected === true} onChange={inputChangeHandler} />
			<span>
				<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
					<line x1="0.106066" y1="0.893934" x2="10.1061" y2="10.8939" stroke="black" strokeWidth="0.5" />
					<line x1="10.1061" y1="1.10607" x2="0.106066" y2="11.1061" stroke="black" strokeWidth="0.5" />
				</svg>
			</span>
			<span className={s.checkbox_content} {...labelAttributes}>{ label }</span>
		</label>
	);
};

export default hot(module)(Checkbox);
